function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { formatClockMinutes, getFixedSlotBoundaries } from '@dutchie/common/utils/slot-geometry';
import _ from 'lodash';
import moment from 'moment-timezone';
import { getSpecialHoursDays, openInfoForDispensary } from 'shared/core/helpers/dispensaries';
import { dayIdToDayOfWeek, daysOfWeek } from 'shared/constants';
import { createTimeSlot, stripNextDaySuffix, hasNextDaySuffix } from 'shared/helpers/time-utils';
export { getSlotDurationMinutes as getReservationSlotDuration } from '@dutchie/common/utils/slot-geometry';
function daysDefault() {
    return {
        Sunday: [],
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: []
    };
}
// Armageddon stores recurrence JSON keys in snake_case; expose the GraphQL camelCase shape.
var normalizeRecurrence = function(recurrence) {
    if (!recurrence || (typeof recurrence === "undefined" ? "undefined" : _type_of(recurrence)) !== 'object') {
        return recurrence;
    }
    var _recurrence_anchorDate;
    var normalizedAnchorDate = (_recurrence_anchorDate = recurrence.anchorDate) !== null && _recurrence_anchorDate !== void 0 ? _recurrence_anchorDate : recurrence.anchor_date;
    var _recurrence_daysOfWeek;
    var normalizedDaysOfWeek = (_recurrence_daysOfWeek = recurrence.daysOfWeek) !== null && _recurrence_daysOfWeek !== void 0 ? _recurrence_daysOfWeek : recurrence.days_of_week;
    return {
        frequency: recurrence.frequency,
        interval: recurrence.interval,
        anchorDate: normalizedAnchorDate,
        daysOfWeek: normalizedDaysOfWeek
    };
};
// Takes slot data coming back from the reservation_slots table and organizes it into maxReservationSlotsByDay and
// maxReservationSlotsByDate for each orderType
export var formatAndOrganizeSlots = function(param) {
    var slots = param.slots, includeCurrentCount = param.includeCurrentCount, includeDayOfWeek = param.includeDayOfWeek, includeSlotId = param.includeSlotId, timezone = param.timezone;
    var orderTypeSlots = {
        curbsidePickup: {
            maxReservationSlotsByDay: daysDefault(),
            maxReservationSlotsByDate: []
        },
        delivery: {
            maxReservationSlotsByDay: daysDefault(),
            maxReservationSlotsByDate: []
        },
        driveThruPickup: {
            maxReservationSlotsByDay: daysDefault(),
            maxReservationSlotsByDate: []
        },
        inStorePickup: {
            maxReservationSlotsByDay: daysDefault(),
            maxReservationSlotsByDate: []
        }
    };
    var sortedSlots = _.sortBy(slots, [
        'reservation_type',
        'day_of_week',
        'start_at'
    ]);
    _.forEach(sortedSlots, function(slot) {
        // if bad order/reservation type is present, ignore
        if (!Object.keys(orderTypeSlots).includes(slot.reservation_type)) {
            return;
        }
        var effectiveDayOfWeek = dayIdToDayOfWeek[slot.day_of_week];
        var orderTypeSlotsConfig = orderTypeSlots[slot.reservation_type];
        // Use the pre-stored flag instead of complex calculation
        var isNextDaySlot = slot.is_next_day_slot;
        var startTime = moment.tz(slot.start_at, 'HH:mm', timezone);
        var formattedSlot = _object_spread({
            startTime: slot.start_at,
            endTime: startTime.add(slot.duration, 'minutes').format('HH:mm'),
            maxOrders: slot.max_orders,
            deliveryAreaId: slot.delivery_area_id,
            active: slot.active,
            isNextDaySlot: isNextDaySlot
        }, includeCurrentCount && _object_spread({
            currentCount: slot.current_count
        }, slot.current_counts_by_date && {
            currentCountsByDate: slot.current_counts_by_date
        }), slot.recurrence && {
            recurrence: normalizeRecurrence(slot.recurrence)
        }, includeDayOfWeek && {
            dayOfWeek: effectiveDayOfWeek
        }, includeSlotId && {
            slotId: slot.id
        });
        if (!slot.valid_to) {
            orderTypeSlotsConfig.maxReservationSlotsByDay[effectiveDayOfWeek].push(formattedSlot);
        } else {
            orderTypeSlotsConfig.maxReservationSlotsByDate.push(_object_spread(_object_spread_props(_object_spread({}, formattedSlot), {
                date: moment(slot.valid_to).tz(timezone).format('YYYY-MM-DD')
            }), includeDayOfWeek && {
                dayOfWeek: effectiveDayOfWeek
            }));
        }
    });
    return orderTypeSlots;
};
// Evaluates weekly recurrence phase for a calendar date. Only an absent recurrence is unrestricted;
// supplied but malformed metadata fails closed so checkout and reservation migration stay aligned.
export var isSlotActiveOnDate = function(slot, dateString, timezone) {
    if ((slot === null || slot === void 0 ? void 0 : slot.recurrence) == null || !dateString) {
        return true;
    }
    var recurrence = slot.recurrence;
    var frequency = recurrence.frequency, interval = recurrence.interval, anchorDate = recurrence.anchorDate, recurringDays = recurrence.daysOfWeek;
    var hasValidDays = Array.isArray(recurringDays) && recurringDays.length > 0 && recurringDays.every(function(day) {
        return Number.isInteger(day) && day >= 0 && day <= 6;
    });
    if (!anchorDate || !Number.isInteger(interval) || interval < 1 || frequency !== 'weekly' || !hasValidDays) {
        return false;
    }
    var targetDateMoment = timezone ? moment.tz(dateString, 'YYYY-MM-DD', true, timezone).startOf('day') : moment.utc(dateString, 'YYYY-MM-DD', true).startOf('day');
    var anchorDateMoment = timezone ? moment.tz(anchorDate, 'YYYY-MM-DD', true, timezone).startOf('day') : moment.utc(anchorDate, 'YYYY-MM-DD', true).startOf('day');
    if (!targetDateMoment.isValid() || !anchorDateMoment.isValid()) {
        return false;
    }
    if (targetDateMoment.isBefore(anchorDateMoment)) {
        return false;
    }
    if (!recurringDays.includes(targetDateMoment.day())) {
        return false;
    }
    // Compare Sunday-based calendar weeks rather than rolling seven-day periods from the anchor.
    // Rebuild the week starts in UTC so a daylight-saving transition cannot change the day count.
    var targetWeekStart = moment.utc(targetDateMoment.format('YYYY-MM-DD')).subtract(targetDateMoment.day(), 'days');
    var anchorWeekStart = moment.utc(anchorDateMoment.format('YYYY-MM-DD')).subtract(anchorDateMoment.day(), 'days');
    var diffWeeks = targetWeekStart.diff(anchorWeekStart, 'weeks');
    return diffWeeks % interval === 0;
};
// Filters date-specific slots to the lookahead window and returns two maps in a single pass:
//   mergedByDayOfWeek — standard day-of-week slots with date-specific overrides merged on top
//   slotOverridesByDate — date-keyed map for exact-date lookups (prevents cross-week contamination)
var mergeOrderTypeSlots = function(orderTypeSlots, timezone) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_dayLimit = _ref.dayLimit, dayLimit = _ref_dayLimit === void 0 ? 6 : _ref_dayLimit;
    var today = moment.tz(timezone).startOf('day');
    var windowEnd = moment.tz(timezone).add(dayLimit, 'days').endOf('day');
    var specialSlotsForDaysOfWeek = {};
    var slotOverridesByDate = {};
    _.forEach(orderTypeSlots.maxReservationSlotsByDate, function(slot) {
        if (!slot.date || !moment.tz(slot.date, timezone).isBetween(today, windowEnd, undefined, '[]')) {
            return;
        }
        if (!specialSlotsForDaysOfWeek[slot.dayOfWeek]) {
            specialSlotsForDaysOfWeek[slot.dayOfWeek] = [];
        }
        specialSlotsForDaysOfWeek[slot.dayOfWeek].push(slot);
        if (!slotOverridesByDate[slot.date]) {
            slotOverridesByDate[slot.date] = [];
        }
        slotOverridesByDate[slot.date].push(slot);
    });
    var mergedByDayOfWeek = _object_spread({}, orderTypeSlots.maxReservationSlotsByDay, specialSlotsForDaysOfWeek);
    return {
        mergedByDayOfWeek: mergedByDayOfWeek,
        slotOverridesByDate: slotOverridesByDate
    };
};
// Resolves the open/close moments of a date-specific special-hours override, if one exists for
// `dateString`. Returns `undefined` when there's no override at all — callers should leave the
// recurring day-of-week schedule untouched in that case, since it isn't this function's job to
// second-guess the base weekly hours (that's a separate, unrelated set of edge cases). Returns
// `null` when the override marks the day fully closed. Mirrors the "open" sentinel (midnight) and
// "(Next Day)" end-time handling `findNextOpenDay` uses, so this agrees with whether the
// dispensary is considered open at all on that date.
var getHoursWindowForDate = function(dateString, specialHours, timezone) {
    var specialHoursDays = getSpecialHoursDays(specialHours, timezone);
    var override = _.find(specialHoursDays, function(param) {
        var date = param.date;
        return date && moment.tz(date, timezone).format('YYYY-MM-DD') === dateString;
    });
    if (!override) {
        return undefined;
    }
    var dayHours = override.hours;
    if (!(dayHours === null || dayHours === void 0 ? void 0 : dayHours.active)) {
        return null;
    }
    var start = dayHours.start === 'open' ? '12:00 AM' : dayHours.start;
    var end = dayHours.end === 'open' ? '12:00 AM' : dayHours.end;
    var isNextDayEnd = dayHours.end === 'open' || hasNextDaySuffix(end);
    var actualEndTime = stripNextDaySuffix(end);
    var dayMoment = moment.tz(dateString, 'YYYY-MM-DD', timezone);
    var openMoment = moment.tz("".concat(dateString, " ").concat(start), 'YYYY-MM-DD hh:mmA', timezone);
    var closeMoment = moment.tz("".concat(dayMoment.clone().add(isNextDayEnd ? 1 : 0, 'day').format('YYYY-MM-DD'), " ").concat(actualEndTime), 'YYYY-MM-DD hh:mmA', timezone);
    return {
        openMoment: openMoment,
        closeMoment: closeMoment
    };
};
// Builds the list of available days (with closure status) for the advanced day ordering window.
export var getAdvancedDayOrderingAvailableDays = function(today, dayLimit, effectiveHoursForOrderType, specialHoursByDate) {
    var availableDays = [];
    for(var i = 0; i <= dayLimit; i++){
        var _effectiveHoursForOrderType_dayOfWeek;
        var currentDay = moment(today).add(i, 'day');
        var dayOfWeek = currentDay.format('dddd');
        // Check date-specific special hours first (handles closures beyond the current week),
        // then fall back to the day-of-week effectiveHours which only covers the current week.
        var dateOverride = specialHoursByDate === null || specialHoursByDate === void 0 ? void 0 : specialHoursByDate[currentDay.format('YYYY-MM-DD')];
        var isClosed = dateOverride !== undefined ? dateOverride.active === false : ((_effectiveHoursForOrderType_dayOfWeek = effectiveHoursForOrderType[dayOfWeek]) === null || _effectiveHoursForOrderType_dayOfWeek === void 0 ? void 0 : _effectiveHoursForOrderType_dayOfWeek.active) === false;
        availableDays.push({
            date: currentDay.format('MM/DD/YYYY'),
            dayOfWeek: dayOfWeek,
            isClosed: isClosed
        });
    }
    return availableDays;
};
// Gets available slot reservations based on formatted data from free_reservation route
export var getCurrentSlotsForOrderType = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(orderType, dispensary, orderTypeSlots) {
        var _ref, _ref_extendedDayOrdering, extendedDayOrdering, _openInfo_orderType, timezone, _dispensary_hoursSettings_orderType, baseHours, effectiveHours, specialHours, _dispensary_orderTypesConfigV2_orderType, enableAfterHoursOrdering, scheduledOrderingConfigV2, openInfo, nextOpenMoment, today, nextOpenDay, todayDate, todayDayOfWeek, nextOpenDate, nextOpenDayOfWeek, _scheduledOrderingConfigV2_nextAvailableInMinutes, nextAvailableBuffer, nextAvailableTime, availableDays, specialHoursByDate, _scheduledOrderingConfigV2_advancedDayOrderingLimit, advancedLimit, windowEnd, specialHoursDays, fallbackHours, _scheduledOrderingConfigV2_advancedDayOrderingLimit1, _scheduledOrderingConfigV2_advancedDayOrderingLimit2, dayLimit, _mergeOrderTypeSlots, mergedOrderTypeSlots, slotOverridesByDate, notDeliveryOrder, hasDateOverrides, availableSlots, sortedSlots;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            _ref = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, _ref_extendedDayOrdering = _ref.extendedDayOrdering, extendedDayOrdering = _ref_extendedDayOrdering === void 0 ? false : _ref_extendedDayOrdering;
            timezone = dispensary.timezone;
            _dispensary_hoursSettings_orderType = dispensary.hoursSettings[orderType], baseHours = _dispensary_hoursSettings_orderType.hours, effectiveHours = _dispensary_hoursSettings_orderType.effectiveHours, specialHours = _dispensary_hoursSettings_orderType.specialHours;
            _dispensary_orderTypesConfigV2_orderType = dispensary.orderTypesConfigV2[orderType], enableAfterHoursOrdering = _dispensary_orderTypesConfigV2_orderType.enableAfterHoursOrdering, scheduledOrderingConfigV2 = _dispensary_orderTypesConfigV2_orderType.scheduledOrderingConfigV2;
            openInfo = openInfoForDispensary(dispensary, {});
            nextOpenMoment = _.get(openInfo, "".concat(orderType, ".nextService.openMoment"));
            if (!nextOpenMoment) {
                return [
                    2,
                    []
                ];
            } // No open hours for this orderType
            today = moment.tz(timezone).startOf('day');
            nextOpenDay = nextOpenMoment.tz(timezone);
            todayDate = today.format('MM/DD/YYYY');
            todayDayOfWeek = today.format('dddd');
            nextOpenDate = nextOpenDay.format('MM/DD/YYYY');
            nextOpenDayOfWeek = nextOpenDay.format('dddd');
            nextAvailableBuffer = (_scheduledOrderingConfigV2_nextAvailableInMinutes = scheduledOrderingConfigV2 === null || scheduledOrderingConfigV2 === void 0 ? void 0 : scheduledOrderingConfigV2.nextAvailableInMinutes) !== null && _scheduledOrderingConfigV2_nextAvailableInMinutes !== void 0 ? _scheduledOrderingConfigV2_nextAvailableInMinutes : 10;
            nextAvailableTime = moment.tz(timezone).add(nextAvailableBuffer, 'minutes');
            availableDays = [];
            if (scheduledOrderingConfigV2 === null || scheduledOrderingConfigV2 === void 0 ? void 0 : scheduledOrderingConfigV2.advancedDayOrderingEnabled) {
                ;
                if (extendedDayOrdering && specialHours) {
                    ;
                    advancedLimit = (_scheduledOrderingConfigV2_advancedDayOrderingLimit = scheduledOrderingConfigV2 === null || scheduledOrderingConfigV2 === void 0 ? void 0 : scheduledOrderingConfigV2.advancedDayOrderingLimit) !== null && _scheduledOrderingConfigV2_advancedDayOrderingLimit !== void 0 ? _scheduledOrderingConfigV2_advancedDayOrderingLimit : 1;
                    windowEnd = moment.tz(timezone).add(advancedLimit, 'days').endOf('day');
                    specialHoursDays = getSpecialHoursDays(specialHours, timezone);
                    specialHoursByDate = {};
                    specialHoursDays.forEach(function(param) {
                        var date = param.date, hours = param.hours;
                        if (moment.tz(date, timezone).isBetween(today, windowEnd, undefined, '[]')) {
                            specialHoursByDate[moment.tz(date, timezone).format('YYYY-MM-DD')] = hours;
                        }
                    });
                }
                // When specialHoursByDate is populated (extended ordering), use baseHours as fallback
                // so that a closure on *this* week's Monday (reflected in effectiveHours) doesn't
                // bleed into future Mondays that have no date-specific override.
                fallbackHours = specialHoursByDate ? baseHours : effectiveHours;
                ;
                availableDays = getAdvancedDayOrderingAvailableDays(today, (_scheduledOrderingConfigV2_advancedDayOrderingLimit1 = scheduledOrderingConfigV2 === null || scheduledOrderingConfigV2 === void 0 ? void 0 : scheduledOrderingConfigV2.advancedDayOrderingLimit) !== null && _scheduledOrderingConfigV2_advancedDayOrderingLimit1 !== void 0 ? _scheduledOrderingConfigV2_advancedDayOrderingLimit1 : 1, fallbackHours, specialHoursByDate);
            } else if (!((_openInfo_orderType = openInfo[orderType]) === null || _openInfo_orderType === void 0 ? void 0 : _openInfo_orderType.isClosed)) {
                availableDays.push({
                    date: todayDate,
                    dayOfWeek: todayDayOfWeek
                });
            } else if (enableAfterHoursOrdering) {
                availableDays.push({
                    date: nextOpenDate,
                    dayOfWeek: nextOpenDayOfWeek
                });
            }
            dayLimit = (_scheduledOrderingConfigV2_advancedDayOrderingLimit2 = scheduledOrderingConfigV2 === null || scheduledOrderingConfigV2 === void 0 ? void 0 : scheduledOrderingConfigV2.advancedDayOrderingLimit) !== null && _scheduledOrderingConfigV2_advancedDayOrderingLimit2 !== void 0 ? _scheduledOrderingConfigV2_advancedDayOrderingLimit2 : 6;
            _mergeOrderTypeSlots = mergeOrderTypeSlots(orderTypeSlots, timezone, {
                dayLimit: dayLimit
            }), mergedOrderTypeSlots = _mergeOrderTypeSlots.mergedByDayOfWeek, slotOverridesByDate = _mergeOrderTypeSlots.slotOverridesByDate;
            notDeliveryOrder = orderType !== 'delivery';
            hasDateOverrides = Object.keys(slotOverridesByDate).length > 0;
            availableSlots = _.reduce(availableDays, function(totalSlots, param) {
                var date = param.date, dayOfWeek = param.dayOfWeek, isClosed = param.isClosed;
                var _orderTypeSlots_maxReservationSlotsByDay;
                if (isClosed) {
                    return totalSlots;
                }
                // Prefer date-specific slots when they exist, otherwise use the day-of-week slots.
                // When date overrides exist but not for this date, fall back to standard (unmerged) day-of-week
                // slots to prevent one Monday's special hours from leaking into a different Monday.
                var normalizedDate = moment.tz(date, 'MM/DD/YYYY', timezone).format('YYYY-MM-DD');
                var exactDateOverrides = hasDateOverrides && slotOverridesByDate[normalizedDate];
                var candidateSlots = exactDateOverrides || (hasDateOverrides ? (_orderTypeSlots_maxReservationSlotsByDay = orderTypeSlots.maxReservationSlotsByDay) === null || _orderTypeSlots_maxReservationSlotsByDay === void 0 ? void 0 : _orderTypeSlots_maxReservationSlotsByDay[dayOfWeek] : mergedOrderTypeSlots === null || mergedOrderTypeSlots === void 0 ? void 0 : mergedOrderTypeSlots[dayOfWeek]);
                // Exact-date manager overrides win over recurrence.
                var effectiveSlots = exactDateOverrides || (candidateSlots || []).filter(function(slot) {
                    return isSlotActiveOnDate(slot, normalizedDate, timezone);
                });
                // `ReservationSlot`s are a recurring day-of-week schedule with no knowledge of
                // date-specific special hours, so a shortened (not fully closed) special-hours day would
                // otherwise still offer the day's full recurring slot list unfiltered. Only clip when a
                // special-hours override actually exists for this date — absent one, leave the recurring
                // schedule exactly as-is. Skip entirely for exact-date overrides too, since those are
                // already a deliberate per-date admin configuration, not the recurring schedule this
                // window governs.
                var hoursWindow = exactDateOverrides ? undefined : getHoursWindowForDate(normalizedDate, specialHours, timezone);
                var slotsPerDay = _.reduce(effectiveSlots, function(slots, slot) {
                    // If it's a "next day" slot, we need to adjust the date to the next day so that the time is technically correct
                    var slotDate = slot.isNextDaySlot ? moment(date, 'MM/DD/YYYY').add(1, 'day').format('MM/DD/YYYY') : date;
                    var capacityDate = moment.tz(slotDate, 'MM/DD/YYYY', timezone).format('YYYY-MM-DD');
                    var _createTimeSlot = createTimeSlot(slot.startTime, slot.endTime, slotDate, timezone), startTimeISO = _createTimeSlot.startTimeISO, endTimeISO = _createTimeSlot.endTimeISO;
                    var startTime = moment(startTimeISO);
                    // Only the slots' start needs to fall within the special-hours window: the last slot
                    // of the day legitimately ends at (or a little after, depending on slot duration
                    // granularity) the close time.
                    if (hoursWindow !== undefined && (!hoursWindow || startTime.isBefore(hoursWindow.openMoment) || !startTime.isBefore(hoursWindow.closeMoment))) {
                        return slots;
                    }
                    var quantityRemaining = 500;
                    if (slot.deliveryAreaId || (scheduledOrderingConfigV2 === null || scheduledOrderingConfigV2 === void 0 ? void 0 : scheduledOrderingConfigV2.orderLimitsEnabled)) {
                        // Armageddon returns an empty map while its rollout is disabled. A populated map is authoritative;
                        // otherwise preserve the legacy scalar behavior so the backend flag remains a complete rollback.
                        var hasDateScopedCounts = _.isPlainObject(slot.currentCountsByDate) && !_.isEmpty(slot.currentCountsByDate);
                        var _slot_currentCountsByDate_capacityDate;
                        var currentCount = hasDateScopedCounts ? (_slot_currentCountsByDate_capacityDate = slot.currentCountsByDate[capacityDate]) !== null && _slot_currentCountsByDate_capacityDate !== void 0 ? _slot_currentCountsByDate_capacityDate : 0 : slot.currentCount;
                        quantityRemaining = slot.maxOrders - currentCount;
                    }
                    // Skip slots with no capacity
                    if (slot.maxOrders === 0) {
                        return slots;
                    }
                    if (notDeliveryOrder) {
                        // Skip slots where nextAvailableTime is after the slot ends (slot is too early)
                        if (nextAvailableTime.isAfter(endTimeISO)) {
                            return slots;
                        }
                    } else if (startTime.isBefore(nextAvailableTime)) {
                        // Skip delivery slots that start before nextAvailableTime
                        return slots;
                    }
                    /*
           * NOTE: currently preventing a quantityRemaining value under 0, even if an admin adjusts the maxOrder value
           * on a timeslot below the currently reserved orders within that timeslot. This could easily be removed if
           * having that information is needed later (in an error warning while updating settings, for example)
           */ slots.push(_object_spread({
                        slotId: slot.slotId,
                        deliveryAreaId: slot.deliveryAreaId,
                        active: slot.active,
                        startTimeISO: startTimeISO,
                        endTimeISO: endTimeISO,
                        quantityRemaining: quantityRemaining < 0 ? 0 : quantityRemaining,
                        isNextDaySlot: slot.isNextDaySlot
                    }, slot.dayOfWeek && {
                        dayOfWeek: slot.dayOfWeek
                    }));
                    return slots;
                }, []);
                return _to_consumable_array(totalSlots).concat(_to_consumable_array(slotsPerDay));
            }, []);
            sortedSlots = _.sortBy(availableSlots, 'startTimeISO');
            return [
                2,
                sortedSlots
            ];
        });
    });
    return function getCurrentSlotsForOrderType(orderType, dispensary, orderTypeSlots) {
        return _ref.apply(this, arguments);
    };
}();
// Fills in currentCount and maxOrders data for a slot based on previous reservationConfig data
var hydrateSlotData = function(reservationOptions, day, startTime, endTime, date) {
    var _reservationOptions_maxReservationSlotsByDay;
    var slots = date ? reservationOptions === null || reservationOptions === void 0 ? void 0 : reservationOptions.maxReservationSlotsByDate : reservationOptions === null || reservationOptions === void 0 ? void 0 : (_reservationOptions_maxReservationSlotsByDay = reservationOptions.maxReservationSlotsByDay) === null || _reservationOptions_maxReservationSlotsByDay === void 0 ? void 0 : _reservationOptions_maxReservationSlotsByDay[day];
    var getMaxOrders = function(maxOrdersValue) {
        if (maxOrdersValue === undefined) {
            return 500;
        }
        if (maxOrdersValue === '') {
            return 0;
        }
        return maxOrdersValue;
    };
    if (!slots) {
        return {
            currentCount: 0,
            maxOrders: 500
        };
    }
    var predicate = date ? function(slot) {
        var slotDate = _.isString(slot.date) ? slot.date : moment.utc(slot.date).format('YYYY-MM-DD');
        return date === slotDate && startTime === slot.startTime && endTime === slot.endTime;
    } : function(slot) {
        return startTime === slot.startTime && endTime === slot.endTime;
    };
    var matchingSlot = _.find(slots, predicate);
    if (matchingSlot) {
        return {
            currentCount: (matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.currentCount) || 0,
            maxOrders: getMaxOrders(matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.maxOrders),
            slotId: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.slotId
        };
    }
    return {
        currentCount: 0,
        maxOrders: 500
    };
};
var hydrateSlotDataV2 = function(reservationOptions, day, startTime, endTime, date, reservationType, zone) {
    var isNextDaySlot = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    var _reservationOptions_maxReservationSlotsByDay;
    var slots = date ? reservationOptions === null || reservationOptions === void 0 ? void 0 : reservationOptions.maxReservationSlotsByDate : reservationOptions === null || reservationOptions === void 0 ? void 0 : (_reservationOptions_maxReservationSlotsByDay = reservationOptions.maxReservationSlotsByDay) === null || _reservationOptions_maxReservationSlotsByDay === void 0 ? void 0 : _reservationOptions_maxReservationSlotsByDay[day];
    var getMaxOrders = function(maxOrdersValue) {
        if (maxOrdersValue === undefined) {
            return 500;
        }
        if (maxOrdersValue === '') {
            return 0;
        }
        return maxOrdersValue;
    };
    if (!slots) {
        return {
            currentCount: 0,
            maxOrders: 500,
            deliveryAreaId: zone.name,
            active: true
        };
    }
    var predicate = date ? function(slot) {
        var slotDate = _.isString(slot.date) ? slot.date : moment.utc(slot.date).format('YYYY-MM-DD');
        var _slot_isNextDaySlot;
        return date === slotDate && startTime === slot.startTime && endTime === slot.endTime && zone.name === slot.deliveryAreaId && ((_slot_isNextDaySlot = slot.isNextDaySlot) !== null && _slot_isNextDaySlot !== void 0 ? _slot_isNextDaySlot : false) === isNextDaySlot;
    } : function(slot) {
        var _slot_isNextDaySlot;
        return startTime === slot.startTime && endTime === slot.endTime && zone.name === slot.deliveryAreaId && ((_slot_isNextDaySlot = slot.isNextDaySlot) !== null && _slot_isNextDaySlot !== void 0 ? _slot_isNextDaySlot : false) === isNextDaySlot;
    };
    var matchingSlot = _.find(slots, predicate);
    if (matchingSlot) {
        return {
            currentCount: (matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.currentCount) || 0,
            currentCountsByDate: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.currentCountsByDate,
            maxOrders: getMaxOrders(matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.maxOrders),
            slotId: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.slotId,
            deliveryAreaId: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.deliveryAreaId,
            active: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.active,
            recurrence: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.recurrence
        };
    }
    return {
        currentCount: 0,
        maxOrders: 500,
        deliveryAreaId: zone.name,
        active: true
    };
};
// Creates slots given a start time up to an end time spaced by increment, hydrating with previously stored maxOrders
var getTimeSlots = function(reservationOptionsForOrderType, day, dayStartTimeString, dayEndTimeString, increment, date, reservationType, deliveryZones, deliveryMode) {
    var actualDayStartTimeString = stripNextDaySuffix(dayStartTimeString);
    var actualDayEndTimeString = stripNextDaySuffix(dayEndTimeString);
    var hasNextDayEnd = hasNextDaySuffix(dayEndTimeString);
    var startTime = actualDayStartTimeString === 'open' ? moment('12:00 AM', 'h:mm A') : moment(actualDayStartTimeString, 'h:mm A');
    var endTime = moment(actualDayEndTimeString, 'h:mm A');
    var startMinutes = startTime.hour() * 60 + startTime.minute();
    var endMinutes = actualDayEndTimeString === 'open' || actualDayEndTimeString === '12:00 AM' ? 24 * 60 : endTime.hour() * 60 + endTime.minute() + (hasNextDayEnd ? 24 * 60 : 0);
    var formattedDate = date ? moment.utc(date).format('YYYY-MM-DD') : undefined;
    var boundaries = getFixedSlotBoundaries({
        startMinutes: startMinutes,
        endMinutes: endMinutes,
        incrementInMinutes: increment,
        hasNextDayEnd: hasNextDayEnd
    });
    var useDrawnZones = deliveryZones && deliveryZones.length > 0 && reservationType === 'delivery' && deliveryMode === 'drawn';
    return boundaries.flatMap(function(param) {
        var slotStart = param.startMinutes, slotEnd = param.endMinutes, isNextDaySlot = param.isNextDaySlot;
        var startTimeString = formatClockMinutes(slotStart);
        var endTimeString = formatClockMinutes(slotEnd);
        if (useDrawnZones) {
            return deliveryZones.map(function(zone) {
                var hydratedSlotData = hydrateSlotDataV2(reservationOptionsForOrderType, day, startTimeString, endTimeString, formattedDate, reservationType, zone, isNextDaySlot);
                return _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, formattedDate && {
                    date: formattedDate
                }), {
                    startTime: startTimeString,
                    endTime: endTimeString,
                    maxOrders: hydratedSlotData.maxOrders,
                    currentCount: hydratedSlotData.currentCount,
                    currentCountsByDate: hydratedSlotData.currentCountsByDate,
                    slotId: hydratedSlotData.slotId,
                    deliveryAreaId: hydratedSlotData.deliveryAreaId,
                    active: hydratedSlotData.active
                }), hydratedSlotData.recurrence && {
                    recurrence: hydratedSlotData.recurrence
                }), {
                    isNextDaySlot: isNextDaySlot
                });
            });
        }
        var hydratedSlotData = hydrateSlotData(reservationOptionsForOrderType, day, startTimeString, endTimeString, formattedDate, reservationType);
        return [
            _object_spread_props(_object_spread({}, formattedDate && {
                date: formattedDate
            }), {
                startTime: startTimeString,
                endTime: endTimeString,
                maxOrders: hydratedSlotData.maxOrders,
                currentCount: hydratedSlotData.currentCount,
                slotId: hydratedSlotData.slotId,
                isNextDaySlot: isNextDaySlot
            })
        ];
    });
};
// Generates all possible slots for a particular order type per day of the week based on an increment
var getOrderTypeSlotsByDay = function(isOrderTypeOffered, orderTypeHours, orderTypeSpecialHours, reservationOptionsForOrderType, reservationType, deliveryZones, deliveryMode) {
    var incrementInMinutes = (reservationOptionsForOrderType === null || reservationOptionsForOrderType === void 0 ? void 0 : reservationOptionsForOrderType.incrementInMinutes) || 30;
    var standardSlots = {};
    var specialSlots = {};
    _.forEach(daysOfWeek, function(day) {
        var dayValue = day.value;
        if (!orderTypeHours[dayValue] || !orderTypeHours[dayValue].active) {
            standardSlots[dayValue] = [];
        } else {
            standardSlots[dayValue] = getTimeSlots(reservationOptionsForOrderType, dayValue, orderTypeHours[dayValue].start, orderTypeHours[dayValue].end, incrementInMinutes, '', reservationType, deliveryZones, deliveryMode);
        }
        if (isOrderTypeOffered && orderTypeSpecialHours[dayValue]) {
            var entries = Array.isArray(orderTypeSpecialHours[dayValue]) ? orderTypeSpecialHours[dayValue] : [
                orderTypeSpecialHours[dayValue]
            ];
            specialSlots[dayValue] = entries.flatMap(function(entry) {
                if (!entry.active) {
                    return [];
                }
                return getTimeSlots(reservationOptionsForOrderType, dayValue, entry.start, entry.end, incrementInMinutes, entry.date, reservationType, deliveryZones, deliveryMode);
            });
        }
    });
    return {
        standard: standardSlots,
        special: specialSlots,
        specialByDate: groupSlotsByDate(specialSlots)
    };
};
// Re-groups a day-of-week-keyed slot map (e.g. `special`) into an exact-date-keyed map, so two
// different occurrences of the same weekday (e.g. two Wednesdays) can be addressed independently
// within a multi-week advanced-ordering window (ECOMM-12919). Every slot already carries its own
// `date` field, so this is a pure re-grouping — no new slots, no generation logic.
var groupSlotsByDate = function(slotsByDayOfWeek) {
    return _.groupBy(_.filter(_.flatten(_.values(slotsByDayOfWeek)), 'date'), 'date');
};
// Gets special hours within the configured lookahead window (defaults to 6 days for backwards compatibility).
// Returns arrays per day-of-week to support multiple instances of the same day (e.g., two Mondays in a 14-day window).
var getUpcomingSpecialHours = function(specialHours, timezone) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_dayLimit = _ref.dayLimit, dayLimit = _ref_dayLimit === void 0 ? 6 : _ref_dayLimit;
    var specialHoursByDayOfWeek = {};
    if (!specialHours) {
        return specialHoursByDayOfWeek;
    }
    var specialHoursDays = getSpecialHoursDays(specialHours, timezone);
    var today = moment().tz(timezone).startOf('day');
    var windowEnd = moment(today).add(dayLimit, 'days').endOf('day');
    var upcomingSpecialHours = _.filter(specialHoursDays, function(param) {
        var date = param.date;
        var specialHoursDate = moment.tz(date, timezone);
        return specialHoursDate.isBetween(today, windowEnd, undefined, '[]');
    });
    _.forEach(upcomingSpecialHours, function(day) {
        var specialHoursDayOfWeek = moment.tz(day.date, timezone).format('dddd');
        if (!specialHoursByDayOfWeek[specialHoursDayOfWeek]) {
            specialHoursByDayOfWeek[specialHoursDayOfWeek] = [];
        }
        specialHoursByDayOfWeek[specialHoursDayOfWeek].push(_object_spread_props(_object_spread({}, day.hours), {
            date: day.date
        }));
    });
    return specialHoursByDayOfWeek;
};
// Updated method to work with new ordering and hours settings by type
/**
 * @typedef {import('types/graphql').GqlWeeklyHours} GqlWeeklyHours
 * @typedef {import('types/graphql').GqlSpecialHours} GqlSpecialHours
 * @typedef {import('types/graphql').GqlReservationOptionsForOrderType} GqlReservationOptionsForOrderType
 *
 * @typedef {Object} SlotsByDay
 * @property {Object} standard - Recurring weekly template, keyed by day-of-week name.
 * @property {Object} special - Special-hours slots, keyed by day-of-week name (collapses multiple
 *   occurrences of the same weekday — see `specialByDate`).
 * @property {Object} specialByDate - `special`'s slots re-keyed by exact date instead of day-of-week
 *   (ECOMM-12919).
 *
 * @typedef {Object} ReservationSlotsPerOrderTypeArgs
 * @property {boolean} orderTypeEnabled
 * @property {GqlWeeklyHours} orderTypeHours
 * @property {GqlSpecialHours[]} orderTypeSpecialHours
 * @property {GqlReservationOptionsForOrderType} orderTypeReservationConfig
 * @property {string} timezone
 * @property {string} reservationType
 * @property {string} deliveryMode
 * @property {GqlDeliveryZones[]} deliveryZones
 *
 * @callback GetReservationSlotsPerOrderType
 * @param {ReservationSlotsPerOrderTypeArgs}
 * @returns {SlotsByDay}
 */ /** @type {GetReservationSlotsPerOrderType}  */ export function getReservationSlotsPerOrderType(param) {
    var _param_orderTypeEnabled = param.orderTypeEnabled, orderTypeEnabled = _param_orderTypeEnabled === void 0 ? false : _param_orderTypeEnabled, _param_orderTypeHours = param.orderTypeHours, orderTypeHours = _param_orderTypeHours === void 0 ? {} : _param_orderTypeHours, _param_orderTypeSpecialHours = param.orderTypeSpecialHours, orderTypeSpecialHours = _param_orderTypeSpecialHours === void 0 ? [] : _param_orderTypeSpecialHours, _param_orderTypeReservationConfig = param.orderTypeReservationConfig, orderTypeReservationConfig = _param_orderTypeReservationConfig === void 0 ? {} : _param_orderTypeReservationConfig, timezone = param.timezone, _param_reservationType = param.reservationType, reservationType = _param_reservationType === void 0 ? '' : _param_reservationType, _param_deliveryZones = param.deliveryZones, deliveryZones = _param_deliveryZones === void 0 ? [] : _param_deliveryZones, _param_deliveryMode = param.deliveryMode, deliveryMode = _param_deliveryMode === void 0 ? '' : _param_deliveryMode;
    // Disabled ordering retains a hidden limit; use it only when enabled.
    var dayLimit = 6;
    if (orderTypeReservationConfig === null || orderTypeReservationConfig === void 0 ? void 0 : orderTypeReservationConfig.advancedDayOrderingEnabled) {
        var _orderTypeReservationConfig_advancedDayOrderingLimit;
        dayLimit = (_orderTypeReservationConfig_advancedDayOrderingLimit = orderTypeReservationConfig.advancedDayOrderingLimit) !== null && _orderTypeReservationConfig_advancedDayOrderingLimit !== void 0 ? _orderTypeReservationConfig_advancedDayOrderingLimit : dayLimit;
    }
    var specialHoursWithinNextWeek = getUpcomingSpecialHours(orderTypeSpecialHours, timezone, {
        dayLimit: dayLimit
    });
    var slotsByDay = getOrderTypeSlotsByDay(orderTypeEnabled, orderTypeHours, specialHoursWithinNextWeek, orderTypeReservationConfig || {}, reservationType, deliveryZones, deliveryMode);
    return slotsByDay;
}
/** Finds the index in advancedDayOrderingDays that matches a reservation, using date when extended ordering is enabled to disambiguate duplicate day-of-week entries. */ export function findSelectedDayIndex(param) {
    var advancedDayOrderingDays = param.advancedDayOrderingDays, reservationOption = param.reservationOption, _param_extendedDayOrdering = param.extendedDayOrdering, extendedDayOrdering = _param_extendedDayOrdering === void 0 ? false : _param_extendedDayOrdering, timezone = param.timezone;
    if (extendedDayOrdering && (reservationOption === null || reservationOption === void 0 ? void 0 : reservationOption.startTimeISO)) {
        var reservationDate = moment.tz(reservationOption.startTimeISO, timezone).format('YYYY-MM-DD');
        return _.findIndex(advancedDayOrderingDays, [
            'date',
            reservationDate
        ]);
    }
    return _.findIndex(advancedDayOrderingDays, [
        'dayOfWeek',
        reservationOption === null || reservationOption === void 0 ? void 0 : reservationOption.dayOfWeek
    ]);
}
export function getAdvancedDayOrderingDays(param) {
    var advancedDayOrderingLimit = param.advancedDayOrderingLimit, timezone = param.timezone, _param_extendedDayOrdering = param.extendedDayOrdering, extendedDayOrdering = _param_extendedDayOrdering === void 0 ? false : _param_extendedDayOrdering;
    var dayOptions = [];
    var getDayString = function(index, day) {
        var dayOfWeek = day.format('dddd');
        var labels = [
            'Today',
            'Tomorrow'
        ];
        // Include the date in labels when extended ordering is enabled to avoid ambiguity
        // when the window exceeds 7 days (e.g., two "Monday" entries become "Monday (3/16)" and "Monday (3/23)")
        var label;
        if (index < labels.length) {
            label = labels[index];
        } else if (extendedDayOrdering) {
            label = "".concat(dayOfWeek, " (").concat(day.format('M/D'), ")");
        } else {
            label = dayOfWeek;
        }
        return {
            day: day,
            dayOfWeek: dayOfWeek,
            date: day.format('YYYY-MM-DD'),
            label: label,
            value: index
        };
    };
    var limit = advancedDayOrderingLimit !== null && advancedDayOrderingLimit !== void 0 ? advancedDayOrderingLimit : 1;
    for(var i = 0; i <= limit; i++){
        dayOptions.push(getDayString(i, moment.tz(timezone).add(i, 'day')));
    }
    return dayOptions;
}
export function filterOpenDays(param) {
    var advancedDayOrderingDays = param.advancedDayOrderingDays, checkoutReservationOptions = param.checkoutReservationOptions, extendedDayOrdering = param.extendedDayOrdering, timezone = param.timezone;
    return advancedDayOrderingDays.filter(function(param) {
        var date = param.date, dayOfWeek = param.dayOfWeek;
        if (extendedDayOrdering) {
            return checkoutReservationOptions.some(function(param) {
                var startTimeISO = param.startTimeISO;
                return startTimeISO && moment.tz(startTimeISO, timezone).format('YYYY-MM-DD') === date;
            });
        }
        return checkoutReservationOptions.some(function(opt) {
            return opt.dayOfWeek === dayOfWeek;
        });
    }).map(function(day, index) {
        return _object_spread_props(_object_spread({}, day), {
            value: index
        });
    });
}
export function sameDayDeliveryAdjustedOrderingDays(advancedDayOrderingLimit, timezone) {
    var extendedDayOrdering = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var options = getAdvancedDayOrderingDays({
        advancedDayOrderingLimit: advancedDayOrderingLimit,
        timezone: timezone,
        extendedDayOrdering: extendedDayOrdering
    });
    options.shift();
    options.forEach(function(option) {
        option.value -= 1;
    });
    return options;
}
export function getAdvancedDayOrderingTimes(param) {
    var _param_advancedDayOrderingDays = param.advancedDayOrderingDays, advancedDayOrderingDays = _param_advancedDayOrderingDays === void 0 ? [] : _param_advancedDayOrderingDays, _param_reservationOptions = param.reservationOptions, reservationOptions = _param_reservationOptions === void 0 ? [] : _param_reservationOptions, _param_selectedDayIndex = param.selectedDayIndex, selectedDayIndex = _param_selectedDayIndex === void 0 ? 0 : _param_selectedDayIndex, _param_extendedDayOrdering = param.extendedDayOrdering, extendedDayOrdering = _param_extendedDayOrdering === void 0 ? false : _param_extendedDayOrdering, timezone = param.timezone;
    var selectedDay = advancedDayOrderingDays[selectedDayIndex];
    if (!selectedDay) {
        return [];
    }
    // When advancedDayOrderingLimit > 7, the same day-of-week name appears multiple times (e.g., two "Monday" entries).
    // Filter by exact date instead of dayOfWeek to avoid conflating slots across different weeks.
    if (extendedDayOrdering && selectedDay.date) {
        var filteredOptions = _.filter(reservationOptions, function(param) {
            var startTimeISO = param.startTimeISO;
            if (!startTimeISO) return false;
            var slotDate = moment.tz(startTimeISO, timezone).format('YYYY-MM-DD');
            return slotDate === selectedDay.date;
        });
        return _.uniqBy(filteredOptions, function(param) {
            var label = param.label;
            return label;
        });
    }
    // Use the effective business day (dayOfWeek) instead of calendar date if extended hours is enabled as that
    // field will be provided on the reservationOptions to compare against
    var selectedDayOfWeek = selectedDay.dayOfWeek;
    var filteredOptions1 = _.filter(reservationOptions, function(param) {
        var dayOfWeek = param.dayOfWeek;
        return dayOfWeek === selectedDayOfWeek;
    });
    return _.uniqBy(filteredOptions1, function(param) {
        var label = param.label;
        return label;
    });
}
